import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

function OrgQRCode({ org, onClose }) {
  const [showPrint, setShowPrint] = useState(false);

  const checkInUrl = `https://saferoster.app/app?org=${org.id}`;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div className="header">
          <h2>📱 QR Code</h2>
          <p>{org.name}</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <div style={{ padding: '20px', background: 'white', borderRadius: '16px', border: '2px solid #eee' }}>
            <QRCodeSVG
              value={checkInUrl}
              size={200}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
            />
          </div>
        </div>

        <p style={{ color: '#666', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
          Parents scan this to check in their child to <strong>{org.name}</strong>
        </p>

        <div style={{ background: '#f8f9ff', borderRadius: '12px', padding: '12px', marginBottom: '20px' }}>
          <p style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>Check-in link:</p>
          <p style={{ fontSize: '13px', color: '#667eea', wordBreak: 'break-all' }}>{checkInUrl}</p>
        </div>

        <button className="btn btn-primary" onClick={handlePrint}>
          🖨️ Print QR Code
        </button>
        <button
          className="btn btn-gray"
          style={{ width: '100%', marginTop: '10px' }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '20px',
};

const modalStyle = {
  background: 'white',
  borderRadius: '20px',
  padding: '30px',
  width: '100%',
  maxWidth: '400px',
  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
};

export default OrgQRCode;